<template>
  <div class="btb-waiver d-flex flex-column flex-grow-1 py-3">
    <b-row align-h="center">
      <b-col cols="12">
        <router-view
          v-on="{
            [events.PersonDetails.COMPLETED]: handleStepComplete,
            [events.Promotion.COMPLETED]: handleStepComplete,
            [events.FollowUpSurvey.COMPLETED]: handleStepComplete,
            [events.Guardian.COMPLETED]: handleStepComplete,
            [events.Contract.COMPLETED]: handleStepFinal,
            [events.Contract.SIGNED]: handleSignatureComplete  // New event listener
          }"
        />
      </b-col>
    </b-row>
    <footer class="mt-auto">
      <NavigationFooter class="my-4"
        :next="nextRoute"
        :back="prevRoute"

        :canProceed="canProceed"
      />
        <!-- :canProceed="canProceed" -->
      <!-- <b-row align-h="center">
        <b-col cols="12" lg="10">
        </b-col>
      </b-row> -->
      <b-row>
        <b-col>
          <b-progress 
            height="2rem"
            :max="progress.max" 
          >
            <b-progress-bar 
              :max="progress.max"
              :precision="progress.precision"
              :value="progression"
              :variant="progress.variant"
            >
              <span>{{ (progression | 0) }}%</span>
            </b-progress-bar>
          </b-progress>
        </b-col>
      </b-row>
    </footer>

    <b-modal centered
      :id="completeModal.id"
      :title="completeModal.title"
    >
      {{ completeModal.content }}
      <template #modal-footer>
        <b-button variant="primary"
          :disabled='isDisabled'
          @click="submitWaiver"
        >
          {{ completeModal.buttonText }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script type="application/javascript" async src="https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Q8Ns4x"></script>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { WaiverRouteChildren } from '@/router';
import { SELECTED_RESERVATION, WAIVER_DISCLAIMER } from '@/store/state';
import { PERSON_DETAILS_EVENTS } from '@/components/Waiver/PersonDetails';
import { PROMOTION_EVENTS } from '@/components/Waiver/Promotion';
import { FOLLOW_UP_SURVEY_EVENTS } from '@/components/Waiver/FollowUpSurvey';
import { GUARDIAN_EVENTS } from '@/components/Waiver/Guardian';
import { CONTRACT_EVENTS } from '@/components/Waiver/Contract';
import NavigationFooter from '@/components/NavigationFooter';
import { SUBMIT_WAIVER } from '@/store/actions';

/**
<span id="selectReservationTime">{{ reservationTimeTitle }}</span>
  <!-- this is the part that displays the time -->
  <div v-for="time in uniqueNames" v-bind:key="time.id">
    <!-- <b-button block pill variant="outline-info" ref="sandes" id="fetchButtonGap" v-model:value="time" v-on:click="showTheTime(); reservationTimeDiv = !reservationTimeDiv ; reservationNameDiv = !reservationNameDiv ;">
        {{time}}
      </b-button> -->
    <pre style="text-align: left;">
      {{ time }}
    </pre>
  </div>
  <!-- end of time display div -->
*/

export default {
  components: {
    NavigationFooter
  },
  data () {
    return {
      currentStepComplete: null,
      events: {
        PersonDetails: PERSON_DETAILS_EVENTS,
        Promotion: PROMOTION_EVENTS,
        FollowUpSurvey: FOLLOW_UP_SURVEY_EVENTS,
        Guardian: GUARDIAN_EVENTS,
        Contract: CONTRACT_EVENTS,
      },
      completeModal: {
        id: 'modal-waiverSubmit',
        title: 'Waiver Complete?',
        buttonText: 'Submit',
        content: 'Click SUBMIT to submit your completed waiver'
      },
      currentlySubmitting: false,
      nextRoute: WaiverRouteChildren[0],
      prevRoute: null,
      progress: {
        max: 100,
        precision: 0,
        value: 0,
        variant: 'success',
      },
      reservationTimeTitle: 'Please select your reservation time:',
      reservationBookingsTime: [],
    }
  },
  computed: {
    ...mapState([
      SELECTED_RESERVATION,
      WAIVER_DISCLAIMER,
    ]),
    canProceed () {
      return !!this.nextRoute && this.currentStepComplete !== null;
    },
    progression () {
      return this.progress.value
    },
    isDisabled(){
      return this.currentlySubmitting;
    }
  },
  mounted () {
    this.setActions();
    this.updateProgress();
  },
  watch: {
    $route (current, prev) {
      this.currentStepComplete = null;

      this.setActions(undefined, prev)
      this.updateProgress()
    }
  },
  methods: {
    determineRoutes (route) {
      const current = route ?? this.$route;
      const currentRouteIdx = WaiverRouteChildren.findIndex((routerConfig) => routerConfig.name === current.name);
      const previous = WaiverRouteChildren[currentRouteIdx-1];
      const next = WaiverRouteChildren[currentRouteIdx+1];
      return {
        current: route,
        previous,
        next,
      }
    },
    formatTime (time, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(time).format(format);
    },
    handleStepComplete (completedStep) {
      this.currentStepComplete = completedStep;
    },
    handleStepFinal (completedStep) {
      this.handleStepComplete(completedStep);
      this.setActions(this.openModal.bind(this))
    },
    openModal () {
      this.$bvModal.show(this.completeModal.id)
    },

    handleSignatureComplete(isSigned) {  // New method to handle signature completion
      this.isSigned = isSigned;
    },

    
    setActions (forward, back) {
      const { previous, current, next } = this.determineRoutes();
      this.prevRoute = back ?? previous;
      this.nextRoute = forward ?? next;
      this.currentlySubmitting = false;
    },
    async submitWaiver () {
      // run the submit action
      this.currentlySubmitting = true;
      const submitted = await this.$store.dispatch(SUBMIT_WAIVER)
      this.currentlySubmitting = false;
      if (submitted) this.$router.push({ name: 'Success' })
    },
    updateProgress () {
      const numerator = WaiverRouteChildren.findIndex(config => config.name === this.$route.name);
      this.progress.value = (numerator / WaiverRouteChildren.length) * 100
    }
  }
}
</script>

<style scoped>
.btb-waiver {
  height: 100%;
}
</style>

